/* eslint-disable lit-a11y/click-events-have-key-events */
/* eslint-disable lit-a11y/mouse-events-have-key-events */
import { html } from 'lit-element';

/**
 * For WAI ARIA guidelines on roles, states, aria-attributes, etc., see:
 * https://www.w3.org/TR/wai-aria-practices-1.1/examples/listbox/listbox-collapsible.html
 *
 * @param {string} arg0.id the id attribute of the option
 * @param {boolean} arg0.isSelected whether or not the option is selected; i.e., whether is be render in the 'selected' style
 * @param {boolean} arg0.isFocused whether or not the option is focused; i.e., whether is be render in the 'focused' style
 * @param {string} arg0.name the name of the option, i.e., what it's displayed label will be in a dropdown
 * @param {function} arg0.icon an svg string which gets passed to an aab-icon
 * @param {boolean} arg0.disabled whether or not the option is disabled
 * @param {function} arg0.onClick callback for when the option is clicked
 * @param {function} arg0.onMouseOver callback for when a mouseover event occurs on an option
 */
export default ({
  id,
  isSelected,
  isFocused,
  name,
  icon,
  disabled,
  onClick,
  onMouseOver,
}) => html`
  <li
    id=${id}
    role="option"
    aria-selected="${isSelected ? 'true' : 'false'}"
    class=${`option
      ${isSelected ? 'option--selected' : ''} ${disabled ? 'option--disabled' : ''} ${isFocused ? 'option--focused' : ''}
    `}
    @click=${() => !disabled && onClick()}
    @mouseover=${onMouseOver}
  >
    ${icon && html`<aab-icon class="option-icon" size="3" svg=${icon}></aab-icon>`}
    
    ${name}
  </li>
`;
